module.exports = __webpack_public_path__ + "media/images/doctor-anywhere-92a06ee8405e51e87f1a76f4a33be956.png";